<template>
  <div>
    <div class="filter_space" v-show="isFixed"></div>
    <div :class="{ 'filter-radio-box': true }" v-show="isCurrentTime !== 'flashSale'" ref="radioBoxScroll">
      <div class="filter-radio-cnt">
        <div
          class="filterItem"
          :class="{
            active: platformShopType === item.platformShopType
          }"
          v-for="(item, index) in platformTypeList"
          :key="index"
          @click="platformChange(item.platformShopType)"
          v-text="item.collectively"
        ></div>
      </div>
    </div>
    <!-- 筛选子选项 -->
    <div id="sch-child" class="sch-child" :class="{ isFixed: isFixed }">
      <div class="sch-child-list">
        <div class="sch-child-item" :class="{ active: currentFilterItem === 'comprehensive' }" @click="filterChange('comprehensive')">
          综合
        </div>
        <div class="sch-child-item" :class="{ active: currentFilterItem === 'new' }" @click="filterChange('new')">
          新品
        </div>
        <div
          class="sch-child-item"
          :class="{
            active: currentFilterItem === 'freeCard'
          }"
          @click="filterChange('freeCard')"
        >
          <div class="con">
            免单卡
            <div class="icon-view">
              <div
                :class="{
                  icon: true,
                  'icon-up': true,
                  'active-up': freeCardNum && freeCardNum % 2 === 0
                }"
              ></div>
              <div
                :class="{
                  icon: true,
                  'icon-down': true,
                  'active-down': freeCardNum && freeCardNum % 2 !== 0
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll'

export default {
  data() {
    return {
      currentFilterItem: 'comprehensive',
      freeCardNum: 0,
      platformShopType: null,
      platformTypeList: [
        {
          platformShopType: null,
          collectively: '全部' // 统称
        },
        {
          platformShopType: 1,
          collectively: '天猫' // 统称
        },
        {
          platformShopType: 2,
          collectively: '拼多多' // 统称
        },
        {
          platformShopType: 3,
          collectively: '京东' // 统称
        },
        {
          platformShopType: 4,
          collectively: '抖音' // 统称
        }
      ]
    }
  },
  props: {
    isFixed: {
      type: Boolean,
      default: false
    },
    isCurrentTime: {
      type: [String, Boolean],
      default: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      // eslint-disable-next-line
      new BScroll(this.$refs.radioBoxScroll, {
        scrollX: true,
        scrollY: false,
        click: true
      })
    })
  },
  methods: {
    reset() {
      this.currentFilterItem = 'comprehensive'
      this.freeCardNum = 0
      this.platformShopType = null
    },
    // 筛选
    filterChange(val) {
      let sort = null
      if (this.currentFilterItem === val && this.currentFilterItem !== 'freeCard') {
        return
      }
      this.currentFilterItem = val
      if (val === 'freeCard') {
        this.freeCardNum += 1
        if (this.freeCardNum % 2 === 0) sort = 'asc'
        else sort = 'desc'
      } else {
        this.freeCardNum = 0
      }
      this.$emit('filterChange', val, sort)
    },
    // 平台筛选
    platformChange(platformShopType = null) {
      if (this.platformShopType !== platformShopType) {
        this.platformShopType = platformShopType
        this.$emit('platformChange', platformShopType)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.filter-radio-box {
  position: relative;
  height: 46px;
  overflow: hidden;
  transition: all 0.15s linear;
  width: 100%;
  background-color: #fff;
}
.filter-radio-cnt {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  box-sizing: border-box;
  padding: 0 2%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.filter-radio-box.fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  background: #fff;
  box-shadow: 0 2px 5px 0 #ccc;
}
.filter_space {
  height: 40px;
  width: 100%;
}
.filter-radio-box .filter-radio {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  line-height: 26px;
  padding: 0 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 14px;
  color: #898989;
  background: #fff;
  border: 1px solid #fff;
  margin-right: 10px;
  border-radius: 20px;
  white-space: nowrap;
  transition: all 0.15s ease-in;
}
.fixed .filter-radio {
  background: #f2f2f2;
}
.filter-radio.active {
  border: 1px solid #f44d4d;
  color: #f44d4d;
  background: #fff;
}
.filter-radio .icon-view {
  margin-left: 5px;
}
.icon-view .icon {
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
}
.icon-view .icon-up {
  margin-bottom: 2px;
  border-bottom: 4px solid;
  border-bottom-color: #999;
}
.icon-view .icon-down {
  border-top: 4px solid;
  border-top-color: #999;
}
.icon-view .active-up {
  border-bottom-color: #000;
}
.icon-view .active-down {
  border-top-color: #000;
}
@media screen and (max-width: 320px) {
  .filter-radio-box .filter-radio {
    padding: 0 6px;
    height: 22px;
    line-height: 22px;
    font-size: 13px;
  }
}
</style>
